import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsaFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M45.9712 4.61015C41.1914 1.59243 35.653 -0.00610633 30.0002 0.000508729V4.61015H45.9712Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0002 9.22055H51.625C49.9336 7.46102 48.0352 5.913 45.9713 4.61035H30.0002V9.22055Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0002 13.8301H55.2618C54.2028 12.1786 52.9847 10.6346 51.625 9.22021H30.0002V13.8301Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0002 18.439H57.6878C57.0154 16.8344 56.2036 15.2919 55.2618 13.8291H30.0002V18.439Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0002 23.0492H59.1814C58.81 21.4743 58.3105 19.9324 57.6878 18.439H30.0002V23.0492Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0002 27.6592H59.8995C59.781 26.1062 59.5407 24.5648 59.1808 23.0493H30.0002V27.6592Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.8995 27.6592H30.0003V29.9999H0C0 30.7641 0.0371811 31.5202 0.0940616 32.2699H59.9057C59.9606 31.5202 60 30.7641 60 29.9999C60 29.2111 59.9586 28.433 59.8995 27.6592Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.801347 36.8794H59.1964C59.5522 35.3637 59.7894 33.8226 59.9056 32.27H0.0940704C0.209576 33.8225 0.446053 35.3637 0.801347 36.8794Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.28413 41.4882H57.7169C58.3341 39.9945 58.8289 38.4532 59.1964 36.8794H0.801315C1.16881 38.4536 1.66474 39.995 2.28413 41.4882Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.6927 46.0987H55.3089C56.2436 44.6347 57.0494 43.0923 57.717 41.4888H2.28424C2.95124 43.0926 3.75712 44.6351 4.6927 46.0987Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.30522 50.7088H51.6927C53.045 49.2934 54.2559 47.7494 55.3081 46.0986H4.69254C5.74496 47.7485 6.95485 49.2925 8.30522 50.7088Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9168 55.3178H46.0836C48.132 54.013 50.0154 52.4655 51.6927 50.709H8.30521C9.98302 52.466 11.8672 54.0135 13.9168 55.3178Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0003 59.9999C35.6985 60.0065 41.2794 58.3819 46.0837 55.3179H13.9169C18.721 58.3822 24.3021 60.0069 30.0003 59.9999Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0282 4.61015C10.0664 7.09606 6.7426 10.4763 4.32375 14.4793C1.90489 18.4824 0.458317 22.9969 0.100166 27.6603C0.0399553 28.4331 0 29.2111 0 30H30.0003V0.000510712C24.3471 -0.00641832 18.8083 1.59213 14.0282 4.61015Z",
			fill: "#428BC1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0001 1L23.4732 2.48247H25.0004L23.7639 3.46234L24.2362 4.97623L23.0001 4.07735L21.764 5.00045L22.2364 3.45817L20.9999 2.48247H22.527L23.0001 1Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9998 7.00049L27.4729 8.48258H28.9996L27.7643 9.46245L28.2362 10.9763L26.9998 10.0775L25.7637 11.0006L26.2356 9.45828L25.0003 8.48258H26.5271L26.9998 7.00049Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 7.00049L19.4731 8.48258H20.9998L19.7637 9.46245L20.2361 10.9763L19 10.0775L17.7639 11.0006L18.2362 9.45828L16.9997 8.48258H18.5269L19 7.00049Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0001 13L23.4732 14.4821H25.0004L23.7639 15.462L24.2362 16.9758L23.0001 16.077L21.764 17.0001L22.2364 15.4578L20.9999 14.4821H22.527L23.0001 13Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 13L15.473 14.4821H16.9998L15.7641 15.462L16.2372 16.9758L15 16.077L13.7639 17.0001L14.2373 15.4578L13.0005 14.4821H14.528L15 13Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.00015 13L7.47324 14.4821H8.99999L7.7639 15.462L8.23737 16.9758L7.00015 16.077L5.76406 17.0001L6.23677 15.4578L4.99992 14.4821H6.52819L7.00015 13Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9998 19.0005L27.4729 20.4822H28.9996L27.7643 21.4621L28.2362 22.9763L26.9998 22.0771L25.7637 23.0002L26.2356 21.4579L25.0003 20.4822H26.5271L26.9998 19.0005Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 19.0005L19.4731 20.4822H20.9998L19.7637 21.4621L20.2361 22.9763L19 22.0771L17.7639 23.0002L18.2362 21.4579L16.9997 20.4822H18.5269L19 19.0005Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9999 19.0005L11.473 20.4822H13.0005L11.7641 21.4621L12.2368 22.9763L10.9999 22.0771L9.76423 23.0002L10.2369 21.4579L9.00009 20.4822H10.5284L10.9999 19.0005Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0001 25L23.4732 26.4821H25.0004L23.7639 27.462L24.2362 28.977L23.0001 28.0762L21.764 29.0001L22.2364 27.4589L20.9999 26.4821H22.527L23.0001 25Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 25L15.473 26.4821H16.9998L15.7641 27.462L16.2372 28.977L15 28.0762L13.7639 29.0001L14.2373 27.4589L13.0005 26.4821H14.528L15 25Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.00015 25L7.47324 26.4821H8.99999L7.7639 27.462L8.23737 28.977L7.00015 28.0762L5.76406 29.0001L6.23677 27.4589L4.99992 26.4821H6.52819L7.00015 25Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.76434 11.0005L10.9999 10.0777L12.2363 10.9764L11.7635 9.4625L13.0005 8.48247H11.473L10.9999 7.00049L10.5271 8.48247H9.10535C9.08898 8.49856 9.07427 8.51243 9.05846 8.52853L10.236 9.45945L9.76434 11.0005Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.76385 23.0003L3.00026 22.0774L4.23584 22.9764L3.76303 21.4622L5 20.4822H3.47308L3.00026 19.0005L2.52745 20.4822H1.55131C1.51191 20.5971 1.4714 20.7103 1.43394 20.8254L2.23748 21.4581L1.76385 23.0003Z",
			fill: "white"
		})
	]
});
export default SvgUsaFlag;
